<template>
  <div style="color: whitesmoke; border-color: whitesmoke">
    <b-row id="back-button" style="margin-top: 15px">
      <b-col class="float-left">
        <div
            class="ico__header"
            @click="handleGoBack">
          <span
              class="ico ico__back"
              @click="activeView = 'crew'"
              v-b-tooltip.hover
              title="Go back"
          >
            <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
              <path
                  d="M28 18H8M8 18L16 10M8 18L16 26"
                  stroke="#606770"
                  stroke-width="2"
                  stroke-linecap="round"
              />
            </svg>
          </span>
          <span></span>
          <span> </span>
          <span> </span>
        </div>
      </b-col>
    </b-row>
    <b-row  style="margin-top: 25px">
      <b-col offset="1">
        <Header
        :tool="tool"
        />
        <Screenshots
            style="margin-top: 25px"
            :tool="tool"
        />
        <Description
            style="margin-top: 25px"
            :tool="tool"
        />
        <detail-info
            style="margin-top: 25px"
            :tool="tool"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Header from "./header";  //Connects with- MyApps, Hardware,
import Screenshots from "./screenshots";
import Description from "./description";
import DetailInfo from "./detailInfo";
export default {
  name: "MyApp_DetailView",
  components: {
    Header,
    Screenshots,
    Description,
    DetailInfo
  },
  props: {
    tool: {
      type: Object,
      default: () => {return {}}
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleGoBack(){
      this.$emit('back-click');
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped></style>
